import { createUseStyles } from 'react-jss';

export default createUseStyles({
  grid: {
    display: 'grid',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateColumns: 'repeat(5, 1fr)',
    // padding: '1%',
    // width: '80vw',
    // height: '50vh',
    // outline: '2px solid black'
},

  // cell:{
  //     outline: '2px solid black',
  //     padding: '10%'
  //   }
});